// axios
import axios from 'axios'

const baseURL = 'http://172.16.1.195:9095'
const baseURL2 = 'https://cvc-fileback.arqbs.com'
const baseURL3 = ''

export default axios.create({
  baseURL3
  // You can add your headers here
})
